import { HttpClient, TFinancialApi } from 'src/generated/services/TFinancialApi';
import { apiConfig } from 'src/config';
import { attachAuthInterceptor, attachCommonErrorInterceptor, attachMetaInterceptor, attachStatusCodeErrorInterceptor } from './interceptors';
import { attachBilledEntitiesInterceptor } from './billedEntitiesInterceptor';
import { attachApiVersionInterceptor } from './apiVersionInterceptor';

const httpClient = new HttpClient({
  timeout: 30 * 1000,
  baseURL: apiConfig.tfinapiEndpointAuthUser,
  paramsSerializer: {
    serialize: (params) => {
      const searchParams = new URLSearchParams();

      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          // For arrays, append each value separately without brackets
          value.forEach((item) => {
            if (item !== null && item !== undefined) {
              searchParams.append(key, String(item));
            }
          });
        } else if (value !== null && value !== undefined) {
          searchParams.append(key, String(value));
        }
      });

      return searchParams.toString();
    },
  },
});

// Order is important here. These interceptors will be executed in reverse order of attachment
attachCommonErrorInterceptor(httpClient.instance);
attachStatusCodeErrorInterceptor(httpClient.instance);
attachMetaInterceptor(httpClient.instance);
attachAuthInterceptor(httpClient.instance);
attachBilledEntitiesInterceptor(httpClient.instance);
attachApiVersionInterceptor(httpClient.instance);
export const tFinancialService = new TFinancialApi(httpClient);
